import assert from 'assert';

import {TableIndex} from 'notebook/tables/constants/TableSelectionConstants';

/** Converst a list of integers into a list of ranges.
 * Ex: [1, 2, 3, 5, 6, 7, 9] => [[1, 3], [5, 7], [9, 9]]
 *
 * This is helpful for TableOps that need to be performed on non-contiguous indexes.
 *
 * @param indexes A list of non-contiguous indexes
 * @returns
 */
export default function toRanges(indexes: Array<number>): Array<TableIndex> {
  if (indexes.length === 0) {
    return [];
  }
  assert(
    indexes.every((index) => Number.isInteger(index)),
    'Every number must be an integer'
  );
  const sortedIndexes = [...indexes].sort((a, b) => a - b);
  const ranges: Array<TableIndex> = [];
  let rangeStart = sortedIndexes[0];
  let rangeEnd = sortedIndexes[0];

  for (let i = 1; i < sortedIndexes.length; i++) {
    if (sortedIndexes[i] === rangeEnd + 1 || sortedIndexes[i] === rangeEnd) {
      rangeEnd = sortedIndexes[i];
    } else {
      ranges.push([rangeStart, rangeEnd]);
      rangeStart = sortedIndexes[i];
      rangeEnd = sortedIndexes[i];
    }
  }
  ranges.push([rangeStart, rangeEnd]);

  return ranges;
}
